import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {MuiThemeProvider, createMuiTheme} from "@material-ui/core/es/styles";
import {BrowserRouter} from "react-router-dom";
import CzechOpenApp from "./containers/CzechOpenApp/CzechOpenApp";
import './i18n';
import {Provider} from "react-redux";
import store from "./store/index";
import {isIE} from 'react-device-detect';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    }
});

function createApp() {
    if (isIE) {
        return (
            <div>
                <h1>Hi there. It looks like you’re using an outdated browser.</h1>
                <p>For a safer and faster user experience use a modern browser like Chrome, Firefox, Safari, Opera, or Edge.</p>
            </div>
        );
    } else {
        return (
            <Suspense fallback="loading">
                <BrowserRouter>
                    <MuiThemeProvider theme={theme}>
                        <Provider store={store}>
                            <CzechOpenApp />
                        </Provider>
                    </MuiThemeProvider>
                </BrowserRouter>
            </Suspense>
        );

    }
}

const app =  (
    <Suspense fallback="loading">
        <BrowserRouter>
            <MuiThemeProvider theme={theme}>
                <Provider store={store}>
                    <CzechOpenApp />
                </Provider>
            </MuiThemeProvider>
        </BrowserRouter>
    </Suspense>
);


ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
